import { useState } from 'react';

import useAnalyticsEffect from 'hooks/useAnalyticsEffect';

import Accolades from './Accolades';
import Billboard from './Billboard';
import DinnerTips from './DinnerTips';
import Faqs from './Faqs';
import FeaturedIn from './FeaturedIn';
import HowItWorks from './HowItWorks';
import MealCarousel from './MealCarousel';
import MealCategories from './MealCategories';
import SatisfactionGuaranteed from './SatisfactionGuaranteed';
import SocialTicker from './SocialTicker';
import ValueProps from './ValueProps';

const FamilyHomeContainer = ({ sectionsData }) => {
  const {
    billboard,
    featuredIn,
    accolades,
    valueProps,
    howItWorks,
    mealCategories,
    mealCarousel,
    satisfactionGuaranteed,
    socialTicker,
    dinnerTips,
    faqs,
  } = sectionsData;
  const [billboardAnimationComplete, setBillboardAnimationComplete] = useState(false);
  const [featuredInAnimationComplete, setFeaturedInAnimationComplete] = useState(false);

  useAnalyticsEffect(({ logEvent, events }) => {
    logEvent(events.familyHome.viewed, {});
  }, []);

  return (
    <>
      <Billboard
        data={billboard}
        onBillboardAnimationComplete={() => setBillboardAnimationComplete(true)}
      />
      <FeaturedIn
        data={featuredIn}
        billboardAnimationComplete={billboardAnimationComplete}
        onFeaturedInAnimationComplete={() => setFeaturedInAnimationComplete(true)}
      />
      <Accolades data={accolades} featuredInAnimationComplete={featuredInAnimationComplete} />
      <ValueProps data={valueProps} />
      <HowItWorks data={howItWorks} />
      <MealCategories data={mealCategories} />
      <MealCarousel data={mealCarousel} />
      <SatisfactionGuaranteed data={satisfactionGuaranteed} />
      <SocialTicker data={socialTicker} />
      <DinnerTips data={dinnerTips} />
      <Faqs data={faqs} />
    </>
  );
};

FamilyHomeContainer.propTypes = {
  sectionsData: PropTypes.object.isRequired,
};

export default FamilyHomeContainer;
